import { Injectable } from '@angular/core';
import { HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';

///////////////////////////////////
// This interceptor will help with preventing IE11 from caching requests to the server
// you should register it in your app if IE11 is one of your target browsers for example
// See: https://medium.com/better-programming/how-to-prevent-http-request-caching-with-angular-httpclient-e82abf8b157d
// See  https://support.microsoft.com/en-us/help/234067/how-to-prevent-caching-in-internet-explorer
//
// In you app.module.ts file:
// ---------------------------
// providers: [
//   {
//     provide: HTTP_INTERCEPTORS,
//     useClass: RequestsCacheBustingInterceptor,
//     multi: true
//   },
//   ...
// ]
//////////////////////////////////

@Injectable({
  providedIn: 'root'
})
export class RequestsCacheBustingInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const httpRequest = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: 'Sat, 01 Jan 2000 00:00:00 GMT'
      }
    });

    return next.handle(httpRequest);
  }
}
